var iOS

function checkUserAgent() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
}

function getScreenWidth() {
  return iOS ? screen.width : window.innerWidth
}

function _calculateScrollbarWidth() {
  var width = getScreenWidth() - document.documentElement.clientWidth + 'px';
  document.documentElement.style.setProperty(
    '--scrollbar-width',
    width
  )
}

document.addEventListener('DOMContentLoaded', function () {
  iOS = checkUserAgent()
  _calculateScrollbarWidth()
  var ro = new ResizeObserver(function () {
    _calculateScrollbarWidth()
  })
  ro.observe(document.body)
})

